import React, { FC, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, hasSpecialCharacters, isSpecificSpecialCharacters, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddRestaurantHeader } from './AddRestaurantHeader';
import PhoneInput from 'react-phone-input-2';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddRestaurantBasicInfo: FC = () => {

    const t = Tr()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '3') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editRestaurantId = (location.state as any)?.restaurantId || '';

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [restaurantDetails, setRestaurantDetails] = useState([]);
    const [restaurantNameEN, setRestaurantNameEN] = useState("");
    const [restaurantNameRU, setRestaurantNameRU] = useState("");
    const [restaurantNameUZ, setRestaurantNameUZ] = useState("");
    const [contactPersonName, setContactPersonName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("998");

    // property type list state start
    const propertyTypeList = [
        { value: 'RESTAURANT', label: t('Restaurant') },
        { value: 'CAFE', label: t('Cafe') }];
    const [propertyTypeSelectedOptions, setPropertyTypeSelectedOptions] = useState<any>();

    const [primaryLanguageList] = useState([
        { value: 'English', label: 'English' },
        { value: 'Russian', label: 'Русский' },
        { value: 'Uzbek', label: 'O’zbekcha' },
    ]);
    const [primaryLanguageSelectedOptions, setPrimaryLanguageSelectedOptions] = useState<any>({ value: 'English', label: 'English' });
    sessionStorage.setItem("primaryLanguage", primaryLanguageSelectedOptions.value);

    const [socialMediaChannelList] = useState([
        { label: 'Instagram', value: 'Instagram' },
        { label: 'Facebook', value: 'Facebook' },
        { label: 'Linkedin', value: 'Linkedin' },
        { label: 'TikTok', value: 'TikTok' },
        { label: 'YouTube', value: 'YouTube' },
        { label: 'Website', value: 'Website' }]);

    const [socialMediaFields, setSocialMediaFields] = useState([
        { socialMediaType: '', socialMediaLink: '' }
    ]);

    const handleAddField = () => {
        setSocialMediaFields([...socialMediaFields, { socialMediaType: '', socialMediaLink: '' }]);
    };

    const handleRemoveField = (index: any) => {
        const updatedFields = socialMediaFields.filter((_, i) => i !== index);
        setSocialMediaFields(updatedFields);
    };

    const handleChange = (index: any, field: any, value: any) => {
        const updatedFields = [...socialMediaFields] as any;
        updatedFields[index][field] = value;
        setSocialMediaFields(updatedFields);
    };

    const getFilteredOptions = (currentIndex: any) => {
        const selectedValues = socialMediaFields.map((field, index) => index !== currentIndex ? field.socialMediaType : '');
        return socialMediaChannelList.filter(option => !selectedValues.includes(option.value));
    };
    // service language list state end
    const changePrimaryLanguage = (val: any) => {
        setPrimaryLanguageSelectedOptions(val);
        removeError("primaryLanguage");
        sessionStorage.setItem("primaryLanguage", val.value);
    }

    // set error state
    const [error, setError] = useState([{
        subCategoryId: '',
        restaurantNameEN: '',
        restaurantNameRU: '',
        restaurantNameUZ: '',
        contactPersonName: '',
        email: '',
        propertyType: '',
        phoneNumber: '',
        primaryLanguage: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }
    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (propertyTypeSelectedOptions == undefined || propertyTypeSelectedOptions == null || propertyTypeSelectedOptions == "") {
            errorTmp[0].propertyType = t('Property Type Is Required');
            isValid = false;
        }
        if (primaryLanguageSelectedOptions.value == "English") {

            if (restaurantNameEN.trim() == "" || restaurantNameEN.trim() == null || restaurantNameEN.trim() == undefined) {
                errorTmp[0].restaurantNameEN = t('Property Name Is Required');
                isValid = false;
            } else if (!isSpecificSpecialCharacters(restaurantNameEN.trim())) {
                errorTmp[0].restaurantNameEN = t("Only <>,.'*() type Of Special Character Are Allow.");
                isValid = false;
            }
        } else if (primaryLanguageSelectedOptions.value == "Russian") {
            if (restaurantNameRU.trim() == "" || restaurantNameRU.trim() == null || restaurantNameRU.trim() == undefined) {
                errorTmp[0].restaurantNameRU = t('Property Name Is Required');
                isValid = false;
            } else if (!isSpecificSpecialCharacters(restaurantNameRU.trim())) {
                errorTmp[0].restaurantNameRU = t("Only <>,.'*() type Of Special Character Are Allow.");
                isValid = false;
            }
        } else if (primaryLanguageSelectedOptions.value == "Uzbek") {
            if (restaurantNameUZ.trim() == "" || restaurantNameUZ.trim() == null || restaurantNameUZ.trim() == undefined) {
                errorTmp[0].restaurantNameUZ = t('Property Name Is Required');
                isValid = false;
            } else if (!isSpecificSpecialCharacters(restaurantNameUZ.trim())) {
                errorTmp[0].restaurantNameUZ = t("Only <>,.'*() type Of Special Character Are Allow.");
                isValid = false;
            }
        }
        if (contactPersonName.trim() == "" || contactPersonName.trim() == null || contactPersonName.trim() == undefined) {
            errorTmp[0].contactPersonName = t('Person Name Is Required');
            isValid = false;
        } else if (!hasSpecialCharacters(contactPersonName.trim())) {
            errorTmp[0].contactPersonName = t('Special Characters Is Not Allow');
            isValid = false;
        }
        if (email == "" || email == undefined || email == null) {
            errorTmp[0].email = t('Email Is Required');
            isValid = false;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
            errorTmp[0].email = t('Please Enter Valid Email.');
            isValid = false;
        }
        if (!phoneNumber) {
            errorTmp[0].phoneNumber = t('Mobile Number Is Required');
            isValid = false;
        } else if (!/^\d+$/.test(phoneNumber)) {
            errorTmp[0].phoneNumber = t('Only Numbers Are Allowed.');
            isValid = false;
        } else {
            // Remove non-numeric characters (like + or spaces)
            const numericPhone = phoneNumber.replace(/\D/g, '');
            // Validate phone number length
            if (numericPhone.length < 10 || numericPhone.length > 15) {
                errorTmp[0].phoneNumber = t('Please Enter Valid Mobile Number');
                isValid = false;
            }
        }
        setError(errorTmp);
        return isValid;
    }
    const isValid = socialMediaFields.every(socialMedia => {
        return socialMedia.socialMediaType && socialMedia.socialMediaLink;
    });
    // add restaurant api call
    const addRestaurantApi = async () => {

        if (validate()) {
            if (isValid) {

                setDisable(true)
                setLoading(true);
                let param: any = {
                    vendorId: String(vendorId),
                    en_name: restaurantNameEN,
                    ru_name: restaurantNameRU,
                    uz_name: restaurantNameUZ,
                    type: propertyTypeSelectedOptions.value,
                    email: email,
                    phoneNo: phoneNumber,
                    primaryLanguage: primaryLanguageSelectedOptions.value,
                    contact_person_name: contactPersonName,
                    socialMediaChannels: socialMediaFields,
                }

                var res = await fetchData("public/addRestraunt", param)
                if (res.status == "200") {
                    toastsuccessmsg(t("Basic Information Saved Successfully!"))
                    var data = res.data[0];
                    sessionStorage.setItem("primaryLanguage", data['primaryLanguage'])
                    const state = {
                        restaurantId: data['restaurantId']
                    }
                    setTimeout(() => {
                        navigate("../addrestaurantlocation/", { state });
                        setDisable(false)
                        setLoading(false);
                    }, 1500);
                }
                else {
                    toasterrormsg(res.message)
                    setDisable(false)
                    setLoading(false);
                }
            } else {
                toasterrormsg(t("Please Fill All Social Media Fields."));
                setLoading(false);
                return;
            }
        }

    }
    // edit restaurant api call
    const editRestaurantApi = async () => {
        if (validate()) {
            if (isValid) {

                setDisable(true)
                setLoading(true);
                let param: any = {
                    vendorId: String(vendorId),
                    restaurantId: String(editRestaurantId),
                    en_name: restaurantNameEN,
                    ru_name: restaurantNameRU,
                    uz_name: restaurantNameUZ,
                    type: propertyTypeSelectedOptions.value,
                    email: email,
                    phoneNo: phoneNumber,
                    primaryLanguage: primaryLanguageSelectedOptions.value,
                    contact_person_name: contactPersonName,
                    socialMediaChannels: socialMediaFields,
                }

                var res = await fetchData("public/addRestraunt", param)
                if (res.status == "200") {
                    toastsuccessmsg(t("Property Updated Successfully!"))
                    var data = res.data[0];
                    sessionStorage.setItem("primaryLanguage", data['primaryLanguage'])
                    const state = {
                        restaurantId: data['restaurantId']
                    }
                    setTimeout(() => {
                        navigate("../addrestaurantlocation/", { state });
                        setDisable(false)
                        setLoading(false);
                    }, 1500);
                }
                else {
                    toasterrormsg(res.message)
                    setDisable(false)
                    setLoading(false)
                }
            } else {
                toasterrormsg(t("Please Fill All Social Media Fields."));
                setLoading(false);
                return;
            }
        }

    }

    //   restaurant list api call
    const restaurantDetailApiCall = async () => {

        var param = {
            'vendorId': vendorId,
            'restaurantId': editRestaurantId
        }
        var res = await fetchData("public/restaurantDetail", param)

        if (res.status == "200") {
            var restaurantData = res.data;
            setRestaurantDetails(restaurantData);

            setPrimaryLanguageSelectedOptions({ value: restaurantData[0].primaryLanguage, label: `${restaurantData[0].primaryLanguage}` })
            if (restaurantData[0].type == "RESTAURANT") {
                setPropertyTypeSelectedOptions({ value: 'RESTAURANT', label: t('Restaurant') })
            } else if (restaurantData[0].type == "CAFE") {
                setPropertyTypeSelectedOptions({ value: 'CAFE', label: t('Cafe') })
            }
            setRestaurantNameEN(restaurantData[0].en_name)
            setRestaurantNameRU(restaurantData[0].ru_name)
            setRestaurantNameUZ(restaurantData[0].uz_name)
            setEmail(restaurantData[0].email)
            setPhoneNumber(restaurantData[0].phoneNo)
            setContactPersonName(restaurantData[0].contact_person_name)
            setSocialMediaFields(restaurantData[0].socialMediaChannels)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    useEffect(() => {

        if (editRestaurantId != "") {
            restaurantDetailApiCall();
        }
    }, [])
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editRestaurantId != "" ? t('Edit Property') : t('Add Property')}</PageTitle>
            <AddRestaurantHeader restaurantId={editRestaurantId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">

                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Property Basic Information')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        restaurantDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    restaurantDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['menu']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Primary Language')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='primaryLanguage[]'
                                                            id='primaryLanguage'
                                                            placeholder={t('Select Primary Language')}
                                                            isSearchable={true}
                                                            options={primaryLanguageList}
                                                            value={primaryLanguageSelectedOptions}
                                                            onChange={(e: any) => { changePrimaryLanguage(e) }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].primaryLanguage}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 required form-label">{t('Property Type')}</label>
                                                        {/* <!--end::Label--> */}
                                                        <Select
                                                            name='propertyType[]'
                                                            id='propertyType'
                                                            placeholder={t('Select Property Type')}
                                                            isSearchable={true}
                                                            options={propertyTypeList}
                                                            value={propertyTypeSelectedOptions}
                                                            onChange={(e: any) => { setPropertyTypeSelectedOptions(e); removeError("propertyType"); }}
                                                        />
                                                        <div className='text-danger fw-bold'>{error[0].propertyType}</div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--begin::Card body--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                {
                                                    primaryLanguageSelectedOptions.value == "English" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Property Name (English)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameEN" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameEN} onChange={(e) => { setRestaurantNameEN(e.target.value); removeError("restaurantNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                    <div className='text-danger fw-bold'>{error[0].restaurantNameEN}</div>
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Property Name (Russian)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameRU" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameRU} onChange={(e) => { setRestaurantNameRU(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Property Name (Uzbek)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameUZ" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameUZ} onChange={(e) => { setRestaurantNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguageSelectedOptions.value == "Russian" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Property Name (Russian)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameRU" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameRU} onChange={(e) => { setRestaurantNameRU(e.target.value) }} />
                                                                    <div className='text-danger fw-bold'>{error[0].restaurantNameRU}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Property Name (English)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameEN" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameEN} onChange={(e) => { setRestaurantNameEN(e.target.value); removeError("restaurantNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Property Name (Uzbek)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameUZ" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameUZ} onChange={(e) => { setRestaurantNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguageSelectedOptions.value == "Uzbek" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Property Name (Uzbek)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameUZ" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameUZ} onChange={(e) => { setRestaurantNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                    <div className='text-danger fw-bold'>{error[0].restaurantNameUZ}</div>
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Property Name (Russian)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameRU" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameRU} onChange={(e) => { setRestaurantNameRU(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Property Name (English)')}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="restaurantNameEN" className="form-control mb-2" placeholder={t("Property Name")} value={restaurantNameEN} onChange={(e) => { setRestaurantNameEN(e.target.value); removeError("restaurantNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="required fs-4 form-label">{t('Contact Person Name')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <input type="text" name="contactPersonName" className="form-control mb-2" placeholder={t("Contact Person Name")} value={contactPersonName} onChange={(e) => { setContactPersonName(e.target.value); removeError("contactPersonName"); }} />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].contactPersonName}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Email')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <input type="text" name="email" className="form-control mb-2" placeholder={t("Email")} value={email} onChange={(e) => { setEmail(e.target.value); removeError("email"); }} />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].email}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Phone Number')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <PhoneInput
                                                            inputClass="form-control form-control-lg form-control-solid w-100"
                                                            placeholder={t('Phone Number')}
                                                            enableSearch={true}
                                                            value={phoneNumber}
                                                            onChange={(e) => { setPhoneNumber(e); removeError("phoneNumber"); }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Social Media Channel')}</label>
                                                        {/* <!--end::Label--> */}
                                                    </div>
                                                </div>
                                                {socialMediaFields.map((field, index) => (
                                                    <div className='row' key={index}>
                                                        <div className="col-lg-4 my-3">
                                                            <Select
                                                                name='socialMediaChannels[]'
                                                                id={`socialMediaChannels-${index}`}
                                                                placeholder={t('Select Social Media Channels')}
                                                                isSearchable={true}
                                                                options={getFilteredOptions(index)}
                                                                value={socialMediaChannelList.find(option => option.value === field.socialMediaType)}
                                                                onChange={(selectedOption: any) => handleChange(index, 'socialMediaType', selectedOption.value)}
                                                            />
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            <input
                                                                type="text"
                                                                className='form-control mb-2'
                                                                name='socialMediaLinks'
                                                                id={`socialMediaLinks-${index}`}
                                                                placeholder={t('Social Media Link')}
                                                                value={field.socialMediaLink}
                                                                onChange={(e) => handleChange(index, 'socialMediaLink', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            <button className='btn btn-success mx-1' type="button" onClick={handleAddField}>+</button>
                                                            {socialMediaFields.length > 1 && index != 0 && (
                                                                <button className='btn btn-danger mx-1' type="button" onClick={() => handleRemoveField(index)}>-</button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <Link to="../viewrestaurants/" id="kt_ecommerce_add_product_cancel" className="btn btn-light me-5">{t('Cancel')}</Link>
                                {/* <!--end::Button--> */}
                                <button type="submit" disabled={disable} className="btn btn-primary" onClick={() => { if (editRestaurantId !== "") { editRestaurantApi(); } else { addRestaurantApi(); } }}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddRestaurantBasicInfo }
